import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, KeepAlive as _KeepAlive, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09a37584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "microAppContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_ctx.is500Page)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createBlock(_component_Layout, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
                  [_vShow, _ctx.isMicroApp]
                ])
              ], 1024)),
              (_openBlock(), _createBlock(_KeepAlive, null, [
                _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(Component), null, null, 512)), [
                  [_vShow, !_ctx.isMicroApp]
                ])
              ], 1024))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}